import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../css/ServiceCompanyTrades.css';
import RegistrationProgressBar from "../components/RegistrationProgressBar";
import tradeCheck from "../../assets/trade_check.png";

function ServiceCompanyTrades() {
    const navigate = useNavigate();
    const [trades, setTrades] = useState([]);
    const [selectedTrades, setSelectedTrades] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        axios.get('/api/trades')
            .then(response => setTrades(response.data))
            .catch(error => console.error('Error fetching trades:', error));
    }, []);

    const getImagePath = (filename) => {
        try {
            return require(`../../assets/trades/${filename}`);
        } catch (error) {
            console.error('Error loading image:', error);
            return null;
        }
    };

    const toggleSelection = (index) => {
        setSelectedTrades((prevSelectedTrades) => {
            if (prevSelectedTrades.includes(index)) {
                return prevSelectedTrades.filter(i => i !== index);
            } else if (selectedTrades.length < 4) {
                return [...prevSelectedTrades, index];
            } else {
                return prevSelectedTrades;
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedTrades.length === 0) {
            setError('Please select at least one trade.');
            return;
        }

        try {
            setError('');
            const response = await axios.post('/api/service_provider_trades', { trades: selectedTrades });

            if (response.status === 200) {
                navigate("/service-company-details");
            } else {
                throw new Error('Unexpected response status');
            }
        } catch (error) {
            setError( 'Failed to submit the form. Please try again.');
        }
    };

    return (
        <div className="serviceCompanyTradesContainer">
            <RegistrationProgressBar elements={[{icon: "dot_blue", label: "Select your trades"}, {icon: "bar_grey"}, {
                icon: "dot_grey",
                label: "Company information"
            }]}/>
            <section className="serviceCompanyTradesFormSection">
                <div className="serviceCompanyTradesFormTitle">Select Your Trades</div>
                <div className="serviceCompanyTradesTradeListContainer">
                    <div className="serviceCompanyTradesWrapper">
                        {trades.length === 0 ? (
                            <p>Loading trades...</p>
                        ) : (
                            trades.map((trade) => (
                                <div
                                    key={trade.id}
                                    className="serviceCompanyTradesTradeWrapper"
                                    onClick={() => toggleSelection(trade.id)}
                                >
                                    <div
                                        className={`serviceCompanyTradesTradeImage ${selectedTrades.includes(trade.id) ? 'selected' : ''}`}>
                                        <img src={getImagePath(trade.icon)} alt={trade.name}/>
                                    </div>
                                    {selectedTrades.includes(trade.id) ? (
                                        <div className="serviceCompanyTradesTradeChecked">
                                            <img src={tradeCheck} alt={'checked'}/>
                                        </div>
                                    ) : null}
                                    <div className="serviceCompanyTradesTradeName">
                                        {trade.name}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </section>

            {error && <div className="serviceCompanyTradesError">{error}</div>}
            <div className="serviceCompanyTradesFormActions">
                <button className="serviceCompanyTradesSubmitButton" onClick={handleSubmit} disabled={selectedTrades.length === 0}>Save and Continue</button>
            </div>
        </div>
    );
}

export default ServiceCompanyTrades;
